<script>
	import { scale } from "svelte/transition";
</script>

<main
	class="parts"
	in:scale={{ start: 0.8, duration: 1000 }}
	out:scale={{ start: 1.2, duration: 1000 }}
>
	<h3>Avantages</h3>
	<p>
		Le <b>développement est rentable</b>, en effet il offre aux développeurs
		un moyen peu coûteux de créer des applications multiplateformes avec
		React Native. Plutôt que de créer deux applications différentes pour
		Android et iOS, le développeur peut déployer le même code pour les deux
		plateformes. Cette fonctionnalité rend également les applications React
		Native moins coûteuses à entretenir. Un projet de développement
		d’application typique nécessite des équipes de développement Android et
		iOS. Un tel arrangement peut entraîner des malentendus et des
		incohérences, par exemple, dans certains cas, l’apparence et les
		fonctions de l’application ne seraient pas les mêmes sur les deux
		plateformes.
		<br />
		<br />
		La capacité de React Native à
		<b>accélérer le développement d’applications</b>
		est l’une des caractéristiques les plus attrayantes de la plateforme. Les
		développeurs tirent profit de divers composants prêts à l’emploi pour créer
		des fonctions d’application plus rapidement que jamais. React Native est
		moins gourmand en code que les autres plateformes de développement. Par conséquent,
		il faut moins d’efforts pour mettre en place les applications React Native.
		<br />
		<br />
		Selon une étude de Statista, JavaScript est le langage de programmation le
		plus utilisé dans le monde, 68% des développeurs écrivent du JavaScript.
		Cela permet aux développeurs JavaScript d’utiliser facilement React Native
		puisque le <b>framework est écrit en JavaScript.</b>
		<br />
		<br />
		Étant donné que React Native est une plateforme open source sous licence
		du MIT, elle permet aux développeurs d’<b>
			accéder gratuitement aux bibliothèques et frameworks d’utilisation.
		</b>
		Il impose quelques restrictions à la réutilisation des logiciels, mais offre
		également une protection juridique aux développeurs.
		<br />
		<br />
		La <b>fonction de rechargement à chaud</b> est l’une des plus utiles et
		des plus attrayantes pour les développeurs. Elle permet au développeur
		d’implémenter des changements dans un code et de voir l’effet sur
		l’application en temps réel. Cela permet de mettre à jour une
		application qui est déjà en ligne. Il suffit d’éditer le code source, et
		la mise à jour est lancée après l’enregistrement du fichier. Les
		développeurs peuvent donc créer des mises à jour sans aucun temps
		d’arrêt.
		<br />
		<br />
		Le site web Statista montre que React Native est
		<b>
			l'un des cadres de développement d’applications multiplateformes les
			plus populaires
		</b>
		de nos jours, avec 38 % de part de marché et 90 000 étoiles sur Github. Ce
		n’est pas surprenant car cela représente une valeur immense pour les développeurs
		d’applications mobiles.
		<br />
		<br />
		Les applications natives ont en effet les meilleures performances globales,
		mais les
		<b>
			applications React Native affichent également des performances
			impressionnantes
		</b>
		comparables aux applications natives. Grâce aux mobiles natifs et aux contrôles
		de React Native apps qui exploitent les composants du système d’exploitation
		natif pour créer des codes pour l’API native sans tracas.
		<br />
		<br />
		React Native s’appuie sur la
		<b>technologie de programmation modulaire</b>
		pour offrir des fonctions sous forme de blocs libres appelés modules ou librairies.
		Cette approche offre un environnement de développement d’applications flexible
		et améliore également la collaboration entre les développeurs. Cela permet
		de créer et d’intégrer facilement des mises à jour d’applications grâce à
		des modules faciles à utiliser, qui sont réutilisables pour les API web et
		mobiles.
		<br />
	</p>
	<h3>Inconvénients</h3>
	<p>
		Malgré toutes les excellentes fonctionnalités, React Native est toujours
		dans la version Beta ! C’est pourquoi elle présente encore quelques
		problèmes apparents, tels que la
		<b>complexité des applications de débogage</b>
		, entre autres limitations, y compris des problèmes de compatibilité. Gardez
		à l’esprit que travailler avec React native peut devenir compliqué lorsque
		le besoin de débogage se fait sentir.
		<br />
		<br />
		Bien que l’expertise de JavaScript puisse vous mener loin dans le développement
		de React Native, vous avez toujours
		<b>besoin du service de développeurs natifs</b>
		pour mettre en œuvre certaines fonctions de l’application. Ainsi, si vous
		avez besoin de mettre en œuvre certaines fonctionnalités uniques, le développeur
		JavaScript moyen ne sera pas en mesure de le faire. Si les développeurs peuvent
		tirer parti des bibliothèques pour effectuer de nombreuses fonctions, elles
		ne seront pas d’un grand secours face aux problèmes natifs. N’oubliez pas
		que vous aurez besoin de l’aide de développeurs natifs dans certains projets
		d’applications.
		<br />
		<br />
		Le fait que React Native ait été développé par Facebook est impressionnant,
		mais cela constitue aussi une des lacunes de la plateforme. Supposons que
		Facebook cesse de fournir une sauvegarde de la plateforme ; tout s’effondrera
		comme un château de cartes. Cependant, de nombreuses autres plateformes offrent
		des fonctions similaires à celles de React Native.
		<br />
		<br />
		React Native crée des applications avec d’excellentes fonctionnalités. Cependant,
		React Native
		<b>
			n’est peut-être pas la meilleure plateforme pour créer des
			applications qui gèrent efficacement les ressources matérielles.
		</b>
		Comme la gestion de la mémoire de React Rative n’est pas la meilleure qui
		soit, elle ne serait pas une plateforme privilégiée pour créer des applications
		performantes. Lorsque vous avez besoin de créer une application qui effectue
		des calculs intensifs, il vaut mieux chercher une autre plateforme de développement.
		<br />
		<br />
		L’innovation dans la technologie mobile est en plein essor ; presque chaque
		nouveau modèle introduit de nouvelles fonctions qui nécessitent de nouvelles
		mises à jour logicielles pour les utiliser efficacement. Bien que React Native
		ait l’habitude de fournir une
		<b>
			assistance pour les nouvelles fonctionnalités du matériel, il arrive
			souvent en retard.
		</b>
		Une assistance native est nécessaire pour utiliser ces fonctionnalités.
		<br />
		<br />
		<b>JavaScript est bien connu pour son retard en matière de sécurité.</b>
		C’est pourquoi JavaScript n’est pas utilisé pour créer des applications qui
		doivent avoir une excellente sécurité. Néanmoins, React Native utilise JavaScript
		pour les tâches de développement de base. Dans cette optique, React Native
		devrait être utilisé pour développer des projets où la sécurité n’est pas
		primordiale. Sinon, un support natif devrait être appliqué pour sécuriser
		les données vitales, telles que les informations de paiement.
		<br />
		<br />
		React Native est idéal pour créer des applications simples avec des visuels
		attrayants. Cependant, il devient
		<b>
			difficile d’obtenir d’excellentes performances lorsque vous devez
			ajouter des fonctionnalités complexes.
		</b>
		Il se peut donc que vous deviez vous contenter de l’un des deux.
		<br />
		<br />
		Comme les codes React Native ne sont pas générés en interne, il peut devenir
		<b>compliqué de résoudre les problèmes spécifiques à un appareil.</b> De
		telles problèmes entraînent des défis compliqués sans qu’il soit
		possible de les résoudre.
		<br />
		<br />
		Les composants nécessaires à la création de certains types d’applications
		manquent dans React Native.
		<b>Vous devez donc utiliser des ressources tierces</b>
		pour ajouter ces composants à votre application. Bien que l’utilisation de
		composants tiers soit acceptable,
		<b>vous pouvez rester bloqué sur la ligne.</b>
		Dans ces moments-là, vous devrez trouver un moyen de résoudre vous-même le
		problème. C’est pourquoi il est délicat d’utiliser un composant tiers dans
		les projets de développement d’applications.
	</p>
</main>
